<!--
 * @Author: DQL
 * @Date: 2020-03-06 11:15:00
 * @LastEditors: DQL
 * @LastEditTime: 2020-04-07 20:26:00
 * @Description: file content
 -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import config from '@/config.js';
import packageconfig from '../package.json';

export default {
  name: 'App',
  data () {
    return {
    };
  },
  beforeCreate () {
    document.title = config.app.name;
    if (config.isFirstNavtab) {
      this.$HMStoreService.setFirstNavTab(config.firstNavtab);
    }
  },
  mounted () {
    this.version = packageconfig.version;
    console.log('当前版本号' + this.version);
  }
};
</script>
